<template>
  <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :show-close="false"
      :modal-append-to-body="false"
  >
    <span>确认注销账号吗！</span>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="offAccount">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: "dialogComponent",
  props:['password','telePhone','code'],
  data() {
    return {
      dialogVisible: false
    };
  },
  watch:{
    isShow(val){
      this.dialogVisible = val
    }
  },
  methods: {
    /**
     * 这个是 处理关闭事件的方法，由名字就可以看出来
     * handler有处理的意思，close是关闭。
     */
    handleClose() {
      this.dialogVisible = true
      /*this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});*/
    },
    /**
     * 注销账户,
     */
    offAccount(){
      //region 要先准备，注销账号接口需要的参数，
      //拿到用户名，
      console.log('弹窗收到的数据',this.password,this.telePhone,this.code)
      const userName = localStorage.getItem('username');
      //密码，验证码，由用户输入，表单的绑定数据获取。
      //手机号这个要问斌哥
      //endregion

      //然后调用注销账号的接口
      this.$api.offAccount(userName,this.password,this.code).then((response)=>{//响应的数据
        //最后处理返回的数据（展示注销成功，或者失败的信息）
        console.log(response);
        if (response.status){
          localStorage.removeItem('token')
          this.$router.replace('/home')
        }else {
          this.$message.error(response.msg)
          this.dialogVisible = false
        }

      });//暂时只传一个，后面的你写吧
    }
  }
}
</script>
